<template>
  <div class="tag-list">
    <el-tag
      v-for="tag in dynamicTags"
      :key="tag"
      closable
      :disable-transitions="false"
      @close="handleClose(tag)"
      >{{ tag }}
    </el-tag>
    <el-input
      v-if="inputVisible"
      ref="InputRef"
      v-model="inputValue"
      class="w-20"
      size="small"
      @keyup.enter="handleInputConfirm"
      @blur="handleInputConfirm"
    />
    <el-button v-else class="button-new-tag" size="small" @click="showInput"
      >+{{ addText }}</el-button
    >
  </div>
</template>

<script setup>
import { computed, nextTick, ref } from "vue";

defineProps({
  addText: {
    default: "添加",
  },
});
const tagsText = defineModel();
const inputValue = ref("");
const dynamicTags = computed({
  get() {
    if (!tagsText.value) return;
    return tagsText.value.split(",").map((tag) => tag.trim());
  },
  set(value) {
    tagsText.value = value.join(",");
  },
});
const inputVisible = ref(false);
const InputRef = ref();

// input 展示回调
const showInput = () => {
  inputVisible.value = true;
  nextTick(() => {
    InputRef.value.input.focus();
  });
};
// tag-input 确认回调
const handleInputConfirm = () => {
  if (inputValue.value) {
    if (tagsText.value.trim()) {
      tagsText.value += `,${inputValue.value}`;
    } else {
      tagsText.value = inputValue.value;
    }
  }
  inputVisible.value = false;
  inputValue.value = "";
};
// tag 关闭回调 -- 删除tag
const handleClose = (tag) => {
  dynamicTags.value = dynamicTags.value.filter((item) => item !== tag);
};
</script>

<style scoped lang="scss">
.tag-list {
  width: 100%;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  .el-input {
    width: 100px;
  }
  .el-button {
    :deep(span) {
      font-size: 14px;
    }
  }
}
</style>
